
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/text-messages",
      function () {
        return require("private-next-pages/android/text-messages/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/text-messages"])
      });
    }
  